<!--
 * @Descripttion: 隐私政策弹窗组件
-->
<template>
  <el-dialog
    v-model="visible"
    :title="$t('privacyPolicy.title')"
    width="60%"
    top="10vh"
    :close-on-click-modal="false"
    custom-class="privacy-dialog"
  >
    <div class="privacy-content" v-html="privacyContent"></div>
    <template #footer>
      <el-button type="primary" @click="visible = false">{{ $t('privacyPolicy.confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { marked } from 'marked'

// i18n locale（小写）到 public/locales 目录名（大小写敏感）的映射
const LOCALE_DIR_MAP = {
  'zh-cn': 'zh-CN',
  'en': 'en'
}

export default {
  name: 'PrivacyPolicyModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      privacyContent: ''
    }
  },
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        if (val && !this.privacyContent) {
          this.loadContent()
        }
      }
    }
  },
  methods: {
    fetchMarkdown(url) {
      return fetch(url).then(response => {
        if (!response.ok) throw new Error('HTTP ' + response.status)
        return response.text()
      })
    },
    loadContent() {
      const locale = (this.$i18n && this.$i18n.locale) || 'zh-cn'
      const dir = LOCALE_DIR_MAP[locale] || 'zh-CN'
      this.fetchMarkdown(`/locales/${dir}/docs/privacy-policy.md`)
        .catch(() => {
          // 目标语言文件缺失时回退到中文版本
          if (dir !== 'zh-CN') {
            return this.fetchMarkdown('/locales/zh-CN/docs/privacy-policy.md')
          }
          throw new Error('fetch failed')
        })
        .then(text => {
          this.privacyContent = marked.parse(text, { breaks: true, gfm: true })
        })
        .catch(() => {
          this.privacyContent = '<p>' + this.$t('privacyPolicy.loadError') + '</p>'
        })
    }
  }
}
</script>

<style>
.privacy-dialog .el-dialog__body {
  padding: 10px 20px;
}
</style>

<style lang="scss" scoped>
.privacy-content {
  max-height: 60vh;
  overflow-y: auto;
  padding: 4px 8px;
  color: #303133;
  line-height: 1.8;
  font-size: 14px;
}

.privacy-content :deep(h1) {
  margin: 0 0 16px 0;
  padding-bottom: 10px;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  border-bottom: 2px solid #409eff;
}

.privacy-content :deep(h2) {
  margin: 24px 0 12px 0;
  padding: 6px 0;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  border-bottom: 1px solid #e4e7ed;
}

.privacy-content :deep(h3) {
  margin: 14px 0 8px 0;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.privacy-content :deep(p) {
  margin: 8px 0;
}

.privacy-content :deep(ul) {
  margin: 8px 0 !important;
  padding-left: 24px !important;
  list-style: disc !important;
}

.privacy-content :deep(ol) {
  margin: 8px 0 !important;
  padding-left: 30px !important;
  list-style: decimal !important;
}

.privacy-content :deep(li) {
  margin: 4px 0 !important;
  padding: 0 !important;
  line-height: 1.8;
  list-style: inherit !important;
}

.privacy-content :deep(strong) {
  font-weight: 700;
  color: #1a1a1a;
}
</style>
